import React from "react";
import { Link } from "react-router-dom";
import { pathIsInArray } from "../utils.js";
import { available } from "../config.js";

export default function CustomTabs({ tabs, location }) {
  return (
    <div className="clearfix relative">
      <div className="tabs-container-master">
        <div className="tabs-container">
          {tabs?.map((tab, i) => {
            if (!available.granel && tab.title === "Granel Habitacional") {
              return null;
            }
            return (
              <Link
                key={i}
                to={typeof tab.to === "string" ? tab.to : tab.to[0]}
              >
                <div
                  className={`tab-container${
                    pathIsInArray(tab.to, location.pathname) ? " selected" : ""
                  }`}
                >
                  <p>{tab.title}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
      <div className="tabs-container-shadow"></div>
    </div>
  );
}
